<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages">
                    <section v-for="article in listeAssociations" :key="article.id">
                        <div class="Fiche">
                            <div class="Infos Contact">
                                <h3>{{article.titre}}</h3>
                                <p class="paragraphe" v-html="article.texte"></p>
                                <div v-for="lien in article.liens" :key="lien.id">
                                    <a :href="lien">{{lien}}</a>
                                </div>
                                <router-link v-for="album in listeAlbums" v-if="album !== null" :key="album.id" :to="{name: 'EnImage', params: {id : album.id}}">
                                    <div class="pochette-Album" v-if="album.id == article.album && album.images !== null && album.images !== false">
                                        <div class="derniereSlide" v-if="album.images[2] != null && album.images[2] != false">
                                            <img :src="album.images[2].url" alt="ArretBusNangis">
                                        </div>
                                        <div class="secondeSlide" v-if="album.images[1] != null && album.images[1] != false">
                                            <img :src="album.images[1].url" alt="ArretBusNangis">
                                        </div>
                                        <div class="premiereSlide" v-if="album.images[0] != null && album.images[0] != false">
                                            <img :src="album.images[0].url" alt="ArretBusNangis">
                                        </div>
                                        <div class="Titre-Album">
                                            <h5>{{album.titre_album}}</h5>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                            <!-- <div class="arret-bus" v-if="article.pdf1 != false">
                                <div class="contenu-droit-page" v-for="pdf in article.pdfs" :key="pdf.id">
                                    <iframe :src="pdf" height="100%" width="100%"></iframe>
                                </div>
                            </div> -->
                            <!-- <div class="arret-bus" v-if="article.pdf1 == false">
                                <div class="contenu-droit-page">
                                    <iframe :src="article.images" height="100%" width="100%"></iframe>
                                </div>
                            </div> -->
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Urbanisme',
    data () {
        return{
            listeAssociations:{
                id:0,
                titre: null,
                type: null,
                texte :null,              
                image:null,
                pdfs: {},
                liens: {},
                album: 0
            },
            listeAlbums:{
                id:0,
                titre_album: null,
                date_de_debut:null,
                date_de_fin: null,
                mots_cles:{
                    term_id:0,
                    name:null
                },
                images:{
                    id: 0,
                    url: null,
                    title: null
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        axios.get(param.host+'association/v1/listeAssociations')
        .then(response =>{
        this.listeAssociations = response.data;
        console.log('mes assos', this.listeAssociations)
            for(var i = 0; this.listeAssociations.length > i; i++){
                    let pdf = new Array;
                    let lien = new Array;
                if(this.listeAssociations[i].pdf1 != null && this.listeAssociations[i].pdf1 != false){
                    pdf[0] = this.listeAssociations[i].pdf1;
                    if(this.listeAssociations[i].pdf2 != null && this.listeAssociations[i].pdf2 != false){
                        pdf[1] = this.listeAssociations[i].pdf2;
                        if(this.listeAssociations[i].pdf3 != null && this.listeAssociations[i].pdf3 != false){
                            pdf[2] = this.listeAssociations[i].pdf3;
                        }
                        
                    } 
                    this.listeAssociations[i].pdfs = pdf
                }
                if(this.listeAssociations[i].lien1 != null && this.listeAssociations[i].lien1 != false){
                    lien[0] = this.listeAssociations[i].lien1;
                    if(this.listeAssociations[i].lien2 != null && this.listeAssociations[i].lien2 != false){
                        lien[1] = this.listeAssociations[i].lien2;
                        if(this.listeAssociations[i].lien3 != null && this.listeAssociations[i].lien3 != false){
                            lien[2] = this.listeAssociations[i].lien3;
                        }
                    }
                    this.listeAssociations[i].liens = lien
                }
            }

            console.log(this.listeAssociations)

        })
        .catch(error => console.log(error))

        axios.get(param.host+'album/v1/listeAlbums')
        .then(response =>{
        this.listeAlbums = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Associations'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Association.vue